import { z } from 'zod';

export function safeMapUrl(value?: string): string | undefined {
  if (!value) return undefined;
  try {
    const url = new URL(value);
    return url.protocol === 'https:' && !url.username && !url.password ? url.href : undefined;
  } catch {
    return undefined;
  }
}
export const mapUrlSchema = z
  .string()
  .max(2000)
  .refine((value) => !!safeMapUrl(value), 'Use an HTTPS map URL without credentials');
export const locationSchema = z
  .object({
    name: z.string().trim().min(1).max(300),
    address: z.string().trim().max(1000),
    details: z.string().max(2000).optional(),
    mapUrl: mapUrlSchema.optional(),
  })
  .strict();
